import SmallHeadingComponent from "../../component/SmallHeadingComponent"
import TextField from "../../component/TextField"
import MoveContentToRight from "../../component/MoveContentToRight"
import Button from "../../component/Button"
import Card from "../../component/Card"
import CenterContents from "../../component/CenterContents"
import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import CheckBox from "../../component/CheckBox"
import { PasswordForgottenResetSpecification } from "pokal_api"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../../navigation/NavigationController"

function PasswordResetView() {
    const navigate = useNavigate()
    const { token, mode } = useParams()

    const [resetToken, setResetToken] = useState<string>(token ?? "")
    const [password, setPassword] = useState<string>("")
    const [passwordValid, setPasswordValid] = useState<boolean>(false)
    const [patient, setPatient] = useState<boolean>(
        mode !== undefined && mode === "patient"
    )

    function submit() {
        PasswordForgottenResetSpecification.request({
            password,
            professional: !patient,
            token: resetToken
        })
            .then(() => navigate(NavigationPaths[NAVIGATION_VIEW.SIGN_IN].path))
            .catch(() => {
                /*Ignore*/
            })
    }

    function submitEnabled(): boolean {
        return password !== "" && token !== "" && passwordValid
    }

    return (
        <CenterContents>
            <Card>
                <div className={"flex flex-col space-y-10"}>
                    <SmallHeadingComponent>
                        Passwort zurücksetzen
                    </SmallHeadingComponent>
                    <TextField
                        inputState={[resetToken, setResetToken]}
                        type={"text"}
                        placeholder={"Token hier eingeben"}
                        label={"Token (aus der Email)"}
                    />
                    <TextField
                        inputState={[password, setPassword]}
                        type={"password"}
                        placeholder={"Neues Passwort hier eingeben"}
                        label={"Neues Passwort"}
                        strengthControl={true}
                        onPasswordValid={() => setPasswordValid(true)}
                        onPasswordInvalid={() => setPasswordValid(false)}
                    />
                    <CheckBox initial={patient} onChange={(p) => setPatient(p)}>
                        Sie nutzen die Platform als Patient:in
                    </CheckBox>
                    <MoveContentToRight>
                        <Button disabled={!submitEnabled()} onClick={submit}>
                            Password zurücksetzen
                        </Button>
                    </MoveContentToRight>
                </div>
            </Card>
        </CenterContents>
    )
}

export default PasswordResetView
